import { Avatar, Box, Button, Checkbox, FormControlLabel, Grid, Grid2, IconButton, InputAdornment, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import { useEffect, useRef, useState } from "react";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import flightIcon from '../../assets/images/flightIcon.svg';
import { useNavigate } from "react-router-dom";
import PhoneIcon from '@mui/icons-material/Phone';
import prevIcon from '../../assets/icons/left-arrow.svg';
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import EmailIcon from '@mui/icons-material/Email';
import nextIcon from '../../assets/icons/right-arrow.svg';
import CloseIcon from '@mui/icons-material/Close';
import threeDots from '../../assets/images/threeDots.svg';
import BlockImg from '../../assets/images/blockImg.svg';
import deleteImg from '../../assets/images/deleteImg.svg';
import PersonIcon from '@mui/icons-material/Person';
import blueCarIcon from '../../assets/icons/blueCar.svg';
import blackSeatIcon from '../../assets/icons/blackSeat.svg';
import bagIcon from '../../assets/icons/Bag.svg';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import pickupIcon from '../../assets/icons/PickupIcon.svg';
import dropIcon from '../../assets/icons/DropIcon.svg';
import { Label } from "flowbite-react";
import dayjs from 'dayjs';
import AddCircleSvg from '../../assets/images/AddCircleSvg.svg';
import SubtractCircleSvg from '../../assets/images/subtractCircleSvg.svg';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import altProfile from '../../assets/images/altProfile.png';
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import Booking from "../airportTransferBooking/Booking.jsx";
import { useGoogleMapsLoader, LIBRARIES } from "../../utils/GoogleMapsLoader";

const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};

var constants = require('../../constant.js');

const AtAssignedTrips = () => {
    const [tokenExpired, setTokenExpired] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '', action:''});
    const [openCancelConfirmModal, setOpenCancelConfirmModal] = useState(false);
    const [bookingToCancel, setBookingToCancel] = useState(null);
    const [bookingtomarkNoShow, setBookingtomarkNoShow] = useState(null);
    const [bookingToDelete, setBookingToDelete] = useState(null);
    const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false);
    const [openMarkNoShowConfirmModal, setOpenMarkNoShowConfirmModal] = useState(false);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));

    const waypointRefs = useRef([]);
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [bookingModeFilter, setBookingModeFilter] = useState('');
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('pickup_time');
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const inputPickupRef = useRef(null);
    const inputDropRef = useRef(null);
    const [pickup, setPickup] = useState('');
    const [drop, setDrop] = useState('');
    const [pickupError, setPickupError] = useState('');
    const [dropError, setDropError] = useState('');
    const [wayPointArr, setWayPointArr] = useState([]);
    const [waypointInputValue, setWaypointInputValue] = useState('');
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [openDetails, setOpenDetails] = useState(false);
    const [openReassign, setOpenReassign] = useState(false);
    const [openUnassign, setOpenUnassign] = useState(false);
    const [unassignDriver, setUnassignDriver] = useState(null);
    const [assignDriver, setAssignDriver] = useState({driver_id: '', vehicle_make_id: ''});
    const [driversData, setDriversData] = useState([]);
    const [vehicleMakeData, setVehicleMakeData] = useState([]);
    const [editVehicleMakeId, setEditVehicleMakeId] = useState('');
    
    console.log(assignDriver,"assign driver")
    
    const [openEditTrip, setOpenEditTrip] = useState(false);
    const [locationsModified, setLocationsModified] = useState(false); 
        const [startDateFilter, setStartDateFilter] = useState(dayjs().startOf('month').startOf('day'));
        const [endDateFilter, setEndDateFilter] = useState(dayjs().endOf('month').startOf('day'));
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [showWaypointInput, setShowWaypointInput] = useState(false);
    const [driverNameFilter, setDriverNameFilter] = useState('');
    const [unfilteredRows, setUnfilteredRows] = useState([]);
    const [customerFirstName, setCustomerFirstName] = useState('');
    const [customerFirstNameError, setCustomerFirstNameError] = useState('');
    const [customerLastName, setCustomerLastName] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerEmailError, setCustomerEmailError] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [customerPhoneError, setCustomerPhoneError] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [price, setPrice] = useState('');
    const [priceError, setPriceError] = useState('');
    const [tax, setTax] = useState('');
    const [bookingId, setBookingId] = useState('');
    const [partnerPrice, setPartnerPrice] = useState('');
    const [extraPrice, setExtraPrice] = useState('');
    const [paymentMode, setPaymentMode] = useState('1');
    const [paymentStatus, setPaymentStatus] = useState('0');
    const [isSaving, setIsSaving] = useState(false);
    const waypointInputRef = useRef(null);  
    const [distance, setDistance] = useState('');
    const [duration, setDuration] = useState('');
    const ischange_point_to_comma = localStorage.getItem('change_point_to_comma');
    const [pickupLat, setPickupLat] = useState('');
    const [pickupLng, setPickupLng] = useState('');
    const [dropLat, setDropLat] = useState('');
    const [dropLng, setDropLng] = useState('');
    const client_id = localStorage.getItem('clientId');
    const [companyNameEdited, setCompanyNameEdited] = useState('');
    const [luggageEdited, setLuggageEdited] = useState('');
    const [childrenCountEdited, setChildrenCountEdited] = useState('');
    const [ticketCountEdited, setTicketCountEdited] = useState('');
    const [flightInfoEdited, setFlightInfoEdited] = useState('');
    const [ticketCountEditedError, setTicketCountEditedError] = useState('');
    const [companyNameEditedError, setCompanyNameEditedError] = useState('');
    // const handleRequestSort = (event, property) => {
    //     const isAsc = orderBy === property && order === 'asc';
    //     setOrder(isAsc ? 'desc' : 'asc');
    //     setOrderBy(property);
    // };
    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const { isLoaded, loadError } = useGoogleMapsLoader();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleMenuOpen = (event, row) => {
        setMenuAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const openConfirmDialog = (action, rowData) => {
        handleMenuClose();
        if(action=='view') setOpenDetails(true);
        if(action=='cancel') {
            setBookingToCancel(rowData || selectedRow); // Use rowData if passed, else fallback to selectedRow
            setOpenCancelConfirmModal(true);
            handleMenuClose(); // Close the three-dots menu
        }
        if(action == 'reassign') {
            setOpenReassign(true);

        }
        if(action == 'unassign') {
            setUnassignDriver(rowData || selectedRow);
            setOpenUnassign(true);

        }
        if(action == 'marknoshow'){
            setBookingtomarkNoShow(rowData || selectedRow);
            setOpenMarkNoShowConfirmModal(true);
            handleMenuClose();
        }
        if(action == 'delete'){
            setBookingToDelete(rowData || selectedRow);
            setOpenDeleteConfirmModal(true);
            handleMenuClose();
        }
        // setSelectedRow(selectedRow);
    };

    const handleClose = () => {
    setOpenReassign(false);
    setSelectedRow(null);
    setAssignDriver({ driver_id: '', vehicle_make_id: '' });
    setEditVehicleMakeId('');
    }

    const handleSubmit = async() => {
    const token = localStorage.getItem('token');
    if(!assignDriver.driver_id || !assignDriver.vehicle_make_id){
        setMessage("Please select driver and vehicle make");
        showSnackbar(true);
        return;
    }
    const payload = {
        token: token,
        booking_id: selectedRow.booking_id,
        driver_id: assignDriver.driver_id,
        vehicle_make_id: assignDriver.vehicle_make_id
    };
    setIsSaving(true);
    try {
        const url = operationsUrl + '/airport/assign_booking';
        const response = await makePostRequestToUrl(url, payload, null, 20000);
        
        if (response.flag === 200) {
        setMessage(`Trip Reassigned Successfully` || 'Driver Reassigned successfully');
        showSnackbar(true);
        setOpenReassign(false);
        setSelectedRow(null);
        setAssignDriver({ driver_id: '', vehicle_make_id: '' });
        setEditVehicleMakeId('');
        
        if (fetchAtAssignedTripsData) {
            fetchAtAssignedTripsData(); // Refresh the data
        }
        } else {
        setMessage(response.message || 'Failed to assign driver');
        showSnackbar(true);
        }
        handleMenuClose();
    } catch (error) {
        console.error('Error', error);
        setMessage(error.message || 'An error occurred'); 
    } finally {
        setIsSaving(false);
        showSnackbar(true);
    }
    }
    console.log(selectedRow,"selected row")

    const handleUnassignSubmit = async() => {
        console.log("unassing hit")
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            booking_id: selectedRow.booking_id,
            driver_id: selectedRow.driver_id,
            vehicle_make_id: selectedRow.vehicle_make_id,
            is_unassigned: 1
        };
        setIsSaving(true);
        try {
            const url = operationsUrl + '/airport/assign_booking';
            const response = await makePostRequestToUrl(url, payload, null, 20000);
            
            if (response.flag === 200) {
            setMessage(`Trip Unassigned Successfully`);
            showSnackbar(true);
            setOpenUnassign(false);
            setSelectedRow(null);            
            if (fetchAtAssignedTripsData) {
                fetchAtAssignedTripsData(); // Refresh the data
            }
            } else {
            setMessage(response.message || 'Failed to assign driver');
            showSnackbar(true);
            }
            handleMenuClose();
        } catch (error) {
            console.error('Error', error);
            setMessage(error.message || 'Failed to unassign driver');
        } finally {
            setIsSaving(false);
            showSnackbar(true);
        }
        }
    
    const fetchDriversData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/airport/fetch_drivers';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setDriversData(response.data);
            }
            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    };

    const fetchVehicleData = async() => {
        try {
            const url = serverUrl + '/vehicle/fetch_vehicle_make';
            const token = localStorage.getItem('token');

            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setVehicleMakeData(response.data);
            }
            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const allowedFields = constants.TripFieldToShow[client_id] || constants.TripFieldToShow[1];

    const allHeaders = [
    'Booking ID',
    'Booking Mode',
    'Source ID',
    'User',
    'Driver',
    'Date & Time',
    'Vehicle Number',
    'Distance (in km)',
    'Duration (in min)',
    'Fare',
    'Tax',
    'Extras',
    'Partner Price',
    'Total Fare',
    'Payment Status',
    'Payment Mode',
    'Status',
    'Parent Booking ID',
    'Journey Code',
    'Action'
    ];

    const visibleHeaders = allowedFields && allowedFields.length > 0
    ? allHeaders.filter(header => allowedFields.includes(header))
    : allHeaders;


    useEffect(() => {
            fetchDriversData();
            fetchVehicleData();
        },[])

    const handleCancelBooking = async() => {
        const token = localStorage.getItem('token');
        const payload = {
          token: token,
          booking_id: selectedRow.booking_id,
        };
        try {
          const url = operationsUrl + '/airport/cancel_booking';
          const response = await makePostRequestToUrl(url,payload, null, 20000);
          if (response.flag === 200) {
            setMessage(response.message)
            showSnackbar(true);
            fetchAtAssignedTripsData();
          } else {
            setMessage(response.message)
            showSnackbar(true);
          }
          handleMenuClose();
        } catch (error) {
          console.error('Error', error);
          setMessage(error.message || 'Failed to cancel booking');
        }
    }

    const handleMarkNoShowBooking = async() => {
        const token = localStorage.getItem('token');
        const payload = {
            token : token,
            booking_id: selectedRow.booking_id,
            booking_status: 11 
        }
        try {
              const url = operationsUrl + '/airport/create_and_update_bookings';
              const response = await makePostRequestToUrl(url, payload, null, 20000);
              if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                // setOpen(false);
                if (fetchAtAssignedTripsData) {
                    fetchAtAssignedTripsData(); // Refresh the data
                }
              }
              else if(response.flag==102){
                localStorage.removeItem('token');
                // setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
              } else {
                setMessage(response.message)
                showSnackbar(true);
              }
            } catch (error) {
              console.error('Error', error);
              setMessage(error.message || 'Failed to mark booking as no-show');
            } finally {
            //   setUpdatingStatusFor(null);
            }
    }


    // };
    const bookingModeOptions = [
        { value: '', label: 'All Modes' },
        { value: '-1', label: 'Admin Panel' },
        { value: '1', label: 'PIU' },
        { value: '2', label: 'Transferz' },
        { value: '0', label: 'Others' },
    ];

    const handleBookingModeChange = (event) => {
        setBookingModeFilter(event.target.value);
    };

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const fetchAtAssignedTripsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/airport/fetch_bookings';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                status: 6,
                start_date: startDateFilter.format('YYYY-MM-DD'),
                end_date: endDateFilter.format('YYYY-MM-DD'),
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Sort data in descending order by pickup_time before setting to state
                const sortedData = response.data.sort((a, b) => {
                    return new Date(b.pickup_time) - new Date(a.pickup_time);
                });
                setUnfilteredRows(sortedData);
                // const formattedData = formatDataForCSV(sortedData);
                // setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    
    useEffect(()=> {
        fetchAtAssignedTripsData();
    },[startDateFilter,endDateFilter, cityFilter])

    useEffect(() => {
        if (!unfilteredRows) {
            setRows([]);
            return;
        }

        let processedRows = unfilteredRows;

        // Apply booking mode filter
        if (bookingModeFilter && bookingModeFilter !== '') {
            processedRows = processedRows.filter(row => String(row.source) === bookingModeFilter);
        }

        // Apply driver name filter
        if (driverNameFilter && driverNameFilter !== '') {
            processedRows = processedRows.filter(row => 
                row.driver_name && 
                row.driver_name.toLowerCase().includes(driverNameFilter.toLowerCase())
            );
        } else if (!bookingModeFilter || bookingModeFilter === '') {
            // If no filters are active (or only bookingModeFilter was 'All'), show all unfilteredRows
            // This condition is slightly complex to ensure driverNameFilter='' doesn't negate a bookingModeFilter
        } 

        setRows(processedRows);
    }, [unfilteredRows, bookingModeFilter, driverNameFilter]);

    const handleCloseDetails = () => {
        setOpenDetails(false);
    }

    const handleOpenEditTrip = (row) => {
        // setSelectedRow(row);
        setOpenEditTrip(true);
        setLocationsModified(false); // Reset flag when opening edit modal
        setCustomerFirstName(row.user_first_name);
        setCompanyNameEdited(row.user_company_name);
        setCustomerLastName(row.user_last_name);
        setCustomerEmail(row.user_email);
        setCustomerPhone(row.user_phone_number);
        setPrice(row.fare);
        setTax(row.tax);
        setTicketCountEdited(row.ticket_count);
        setLuggageEdited(row.luggage_count);
        setChildrenCountEdited(row.no_of_childrens);
        setFlightInfoEdited(row.flight_number);
        setPickupLat(row.pickup_latitude || '');
        setPickupLng(row.pickup_longitude || '');
        setDropLat(row.drop_latitude || '');
        setDropLng(row.drop_longitude || '');
        setBookingId(row.booking_id);
        setPartnerPrice(row.partner_fare);
        setExtraPrice(row.extra_fare);
        setPaymentMode(row.payment_mode);
        setPaymentStatus(row.payment_status);
        setPickup(row.pickup_address || '');
        setDrop(row.drop_address || '');
        setDistance(row.distance);
        setDuration(row.duration || '');
        if (Array.isArray(row.way_points) && row.way_points.length > 2) {
            setWayPointArr(row.way_points.slice(1, row.way_points.length - 1));
        } else {
            setWayPointArr([]);
        }
        setTicketCountEditedError('');
        setPickupError('');
        setDropError('');
        setPriceError('');
        setCustomerEmailError('');
        setCustomerPhoneError('');
        setCustomerFirstNameError('');
        setCompanyNameEditedError('');
    }

    const handleCloseEditTripModal = () => {
        setOpenEditTrip(false);
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };
    
    const exportCSV = () => {
        // Define which columns to include in the CSV
        const headers = [
            'Booking ID',
            'Booking Mode',
            'Source ID',
            'Customer Name',
            'Phone Number',
            'Email',
            'Company Name',
            'Pickup Address',
            'Drop Address',
            'Stops',
            'Pickup Time',
            'Number of Seats',
            'Number of Children',
            'Luggage Count',
            'Driver Name',
            'Driver Email',
            'Driver Phone Number',
            'Vehicle Number',
            'Distance',
            'Duration',
            'Fare',
            'Tax',
            'Partner Price',
            'Extra Price',
            'Total Fare',
            'Payment Mode',
            'Payment Status',
            'Flight Number',
            'Journey Code',
            'Parent Booking ID',
            // 'Booking Status',
            'Driver Remarks',
            'Self Remarks'
        ];

        // Map the data rows to match the headers
        const csvData = rows.map(row => {
            const stopsString = row.way_points
            ? row.way_points
                .map((item, index) =>
                    (index !== 0 && index !== row.way_points.length - 1)
                        ? `${index}) ${item.address}`
                        : null
                )
                .filter(Boolean)
                .join('\n')
            : '';

            return [
                row.booking_id,
                row.source==1 ? 'PIU' : row.source==2 ? 'Transferz' : row.source==0 ? 'Others' : row.source==-1 ? 'Admin Panel' : 'Unknown',
                row.source_id,
                `${row.user_first_name || ''} ${row.user_last_name || ''}`,
                row.user_phone_number || '',
                row.user_email || '',
                row.user_company_name || '',
                row.pickup_address || '',
                row.drop_address || '',
                stopsString,
                dayjs(row.pickup_time).format('DD-MM-YYYY HH:mm') || '',
                row.ticket_count || '0',
                row.no_of_childrens || '0',
                row.luggage_count || '0',
                row.driver_name || '--',
                row.driver_email || '--',
                row.driver_phone || '--',
                row.vehicle_number || '--',
                row.distance || '0',
                row.duration || '0',
                row.fare || '0',
                row.tax || '0',
                row.partner_fare || '0',
                row.extra_fare || '0',
                (Number(row.fare) + Number(row.tax) + Number(row.partner_fare) + Number(row.extra_fare)) || '0',
                row.payment_mode==1 ? 'Cash' : row.payment_mode==2 ? 'Prepaid' : 'Unknown' || '',
                row.payment_status==0 ? 'Pending' : row.payment_status==1 ? 'Paid' : 'Unknown' || '',
                row.flight_number || '--',
                row.journey_code || '--',
                row.linked_booking_id || '--',
                row.driver_remarks || '--',
                row.self_remarks || '--'
            ];
        });

        // Create CSV content
        let csvContent = headers.join(',') + '\n';
        
        csvData.forEach(rowArray => {
            // Properly escape fields that might contain commas
            const formattedRow = rowArray.map(field => {
                // Convert to string and check if it needs quotes
                const stringField = String(field || '');
                if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
                    // Escape quotes and wrap in quotes
                    return `"${stringField.replace(/"/g, '""')}"`;  
                }
                return stringField;
            });
            csvContent += formattedRow.join(',') + '\n';
        });

        // Create a blob and download link
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        // Set up download attributes
        const date = new Date().toISOString().slice(0, 10);
        link.setAttribute('href', url);
        link.setAttribute('download', `assigned_trips_${date}.csv`);
        link.style.visibility = 'hidden';
        
        // Append to document, trigger download, and clean up
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const editAssignedTrip = async() => {
        // Validate all required fields
        let hasError = false;
        
        // Validate pickup location
        if (!pickup) {
            setPickupError('Pickup location is required');
            hasError = true;
        }
        
        // Validate drop location
        if (!drop) {
            setDropError('Drop location is required');
            hasError = true;
        }
        
        // Validate customer details
        if (!customerFirstName) {
            setCustomerFirstNameError('First name is required');
            hasError = true;
        }
        
        if (!customerEmail) {
            setCustomerEmailError('Email is required');
            hasError = true;
        } else if (!validateEmail(customerEmail)) {
            setCustomerEmailError('Please enter a valid email address');
            hasError = true;
        }
        
        if (!customerPhone) {
            setCustomerPhoneError('Phone number is required');
            hasError = true;
        }
        
        if (!companyNameEdited) {
            setCompanyNameEditedError('Company name is required');
            hasError = true;
        }
        
        // Validate price
        if (!price) {
            setPriceError('Price is required');
            hasError = true;
        }
        
        // Validate ticket count
        if (!ticketCountEdited) {
            setTicketCountEditedError('Number of seats is required');
            hasError = true;
        }
        
        // If any validation error, don't proceed
        if (hasError) {
            setMessage('Please fill in all required fields');
            showSnackbar(true);
            setIsSaving(false);
            return;
        }
        
        setIsSaving(true);
        const token = localStorage.getItem('token');
        const finalWaypoints = [];
        // Add pickup as first stop
        finalWaypoints.push({
            address: pickup,
            stop_id: 1,
            latitude: pickupLat,
            longitude: pickupLng
        });
        // Add all waypoints, incrementing stop_id
        wayPointArr.forEach((wp, idx) => {
            finalWaypoints.push({
                ...wp,
                stop_id: idx + 2 // pickup is 1
            });
        });
        // Add drop as last stop
        finalWaypoints.push({
            address: drop,
            stop_id: finalWaypoints.length + 1,
            latitude: dropLat,
            longitude: dropLng
        });

        const payload = {
          token: token,
          booking_id: bookingId,
          user_first_name: customerFirstName,
          user_last_name: customerLastName,
          user_email: customerEmail,
          user_phone_number: customerPhone,
          fare: ischange_point_to_comma == '1'? String(price).replace(/,/g, '.'):price,
          payment_mode: paymentMode,
          payment_status: paymentStatus == 1 ? 1 : 0,
          pickup_latitude: pickupLat,
          pickup_longitude: pickupLng,
          drop_latitude: dropLat,
          drop_longitude: dropLng,
          pickup_address: pickup,
          drop_address: drop,
          distance: distance,
          duration: duration,
          ticket_count: ticketCountEdited,
          user_company_name: companyNameEdited,
        };
        if(tax){
          payload.tax = ischange_point_to_comma == '1'? String(tax).replace(/,/g, '.') : tax;
        }
        if(extraPrice){
          payload.extra_fare = ischange_point_to_comma == '1'? String(extraPrice).replace(/,/g, '.') : extraPrice;
        }
        if(partnerPrice){
            payload.partner_fare = ischange_point_to_comma == '1'? String(partnerPrice).replace(/,/g, '.') : partnerPrice;
        }
        if(luggageEdited){
          payload.luggage_count = luggageEdited;
        }
        if(childrenCountEdited){
          payload.no_of_childrens = childrenCountEdited;
        }
        if(flightInfoEdited){
          payload.flight_number = flightInfoEdited;
        }
        if(wayPointArr.length) payload.way_points = finalWaypoints;
        else payload.way_points = [];

        try {
          const url = operationsUrl + '/airport/create_and_update_bookings';
          const response = await makePostRequestToUrl(url,payload, null, 20000);
          if (response.flag === 200) {
            setMessage(response.message)
            showSnackbar(true);
            fetchAtAssignedTripsData();
            setOpenEditTrip(false);
          } else {
            setMessage(response.message)
            showSnackbar(true);
          }
          handleMenuClose();
        } catch (error) {
          console.error('Error', error);
          setMessage(error.message || 'Failed to edit booking');
        } finally {
            setIsSaving(false);
        }
    }
    

    const handleDeleteBooking = async () => {
        const token = localStorage.getItem('token');
        const payload = {
          token: token,
          booking_id: selectedRow.booking_id,
          booking_status: -1,
        };
        try {
          const url = operationsUrl + '/airport/create_and_update_bookings';
          const response = await makePostRequestToUrl(url, payload);
          if (response.flag === 200) {
            setMessage(response.message)
            showSnackbar(true);
            setOpenDeleteConfirmModal(false);
            fetchAtAssignedTripsData();
          }
          else if(response.flag==102){
            localStorage.removeItem('token');
            // setErrorMessage('Your session has expired. Please log in again.');
            setTokenExpired(true);
            setTimeout(() => {
                navigate('/signup');
            }, 2000);
          } else {
            setMessage(response.message)
            showSnackbar(true);
          }
        } catch (error) {
          console.error('Error', error);
          setMessage(error.message || 'Failed to delete booking');
        }
    };

    const formatNumber = (num) => {
        return num?.toString().replace('.', ',');
    };

    // Function to calculate distance and duration using Directions API
    const calculateRoute = (origin, destination, waypoints = []) => {
        if (!origin || !destination || !window.google || !window.google.maps) return;
        
        const directionsService = new window.google.maps.DirectionsService();
        
        // Format waypoints for the directions API if they exist and have valid coordinates
        const formattedWaypoints = [];
        
        if (waypoints && waypoints.length > 0) {
            // Process each waypoint to ensure valid coordinates
            waypoints.forEach((wp, index) => {
                if (!wp || !wp.latitude || !wp.longitude) {
                    return;
                }
                
                // Ensure coordinates are parsed as floats
                const lat = parseFloat(wp.latitude);
                const lng = parseFloat(wp.longitude);
                
                if (isNaN(lat) || isNaN(lng)) {
                    return;
                }
                
                formattedWaypoints.push({
                    location: { lat, lng },
                    stopover: true
                });
            });
        }
        
        // Parse origin and destination coordinates as float to ensure proper calculation
        const originCoords = { 
            lat: parseFloat(origin.lat), 
            lng: parseFloat(origin.lng) 
        };
        const destCoords = { 
            lat: parseFloat(destination.lat), 
            lng: parseFloat(destination.lng) 
        };
        
        directionsService.route(
            {
                origin: originCoords,
                destination: destCoords,
                waypoints: formattedWaypoints,
                travelMode: window.google.maps.TravelMode.DRIVING,
                optimizeWaypoints: false // Keep waypoints in original order
            },
            (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    console.log('Directions result:', result);
                    
                    // Get total distance in kilometers
                    const totalDistance = result.routes[0].legs.reduce(
                        (total, leg) => total + leg.distance.value, 0
                    ) / 1000; // Convert meters to kilometers
                    
                    // Get total duration in minutes
                    const totalDuration = Math.ceil(
                        result.routes[0].legs.reduce(
                            (total, leg) => total + leg.duration.value, 0
                        ) / 60 // Convert seconds to minutes
                    );
                    
                    console.log(`Calculated distance: ${totalDistance} km, duration: ${totalDuration} mins`);
                    
                    // Set the calculated values
                    setDistance(totalDistance.toFixed(2));
                    setDuration(totalDuration);
                } else {
                    console.error('Directions request failed due to ' + status);
                }
            }
        );
    };
    
    // Effect for recalculating route whenever waypoints, pickup or drop locations change
    useEffect(() => {
        // Only calculate if we have both pickup and drop locations set
        // AND if we're not in edit mode OR if locations have been modified while in edit mode
        if (pickupLat && pickupLng && dropLat && dropLng && window.google && window.google.maps && 
            (!openEditTrip || locationsModified)) {
            const origin = { 
                lat: parseFloat(pickupLat), 
                lng: parseFloat(pickupLng) 
            };
            const destination = { 
                lat: parseFloat(dropLat), 
                lng: parseFloat(dropLng) 
            };
            
            // This ensures distance and duration always include all waypoints
            calculateRoute(origin, destination, wayPointArr);
        }
    }, [pickupLat, pickupLng, dropLat, dropLng, wayPointArr, openEditTrip, locationsModified]);

    useEffect(() => {
        const loadAutocomplete = () => {
            if (window.google && window.google.maps && window.google.maps.places) {
                // Setup autocomplete for pickup location
                const pickupAutocomplete = new window.google.maps.places.Autocomplete(inputPickupRef.current, {
                    types: ['geocode', 'establishment']
                });
                pickupAutocomplete.addListener('place_changed', () => {
                    const place = pickupAutocomplete.getPlace();
                    if (place.geometry) {
                        const lat = place.geometry.location.lat();
                        const lng = place.geometry.location.lng();
                        
                        setPickup(place.formatted_address || '')
                        setPickupLat(lat)
                        setPickupLng(lng)
                        setLocationsModified(true) // Set flag when user selects a new pickup location
                    }
                });
                
                // Setup autocomplete for drop location
                const dropAutocomplete = new window.google.maps.places.Autocomplete(inputDropRef.current, {
                    types: ['geocode', 'establishment']
                });
                dropAutocomplete.addListener('place_changed', () => {
                    const place = dropAutocomplete.getPlace();
                    if (place.geometry) {
                        const lat = place.geometry.location.lat();
                        const lng = place.geometry.location.lng();
                        
                        setDrop(place.formatted_address || '')
                        setDropLat(lat)
                        setDropLng(lng)
                        setLocationsModified(true) // Set flag when user selects a new drop location
                        
                        // If pickup is already set, calculate route
                        if (pickupLat && pickupLng) {
                            const origin = { 
                                lat: parseFloat(pickupLat), 
                                lng: parseFloat(pickupLng) 
                            };
                            const destination = { 
                                lat: parseFloat(lat), 
                                lng: parseFloat(lng) 
                            };
                            
                            // Make sure we're using waypoints if they exist
                            // if (wayPointArr && wayPointArr.length > 0) {
                            //     console.log('Including waypoints in route calculation:', wayPointArr);
                            // }
                            
                            calculateRoute(origin, destination, wayPointArr);
                        }
                    }
                });
                // Setup autocomplete for the single waypoint input
                if (waypointInputRef.current && !waypointInputRef.current._autocompleteAttached) {
                    const waypointAutocomplete = new window.google.maps.places.Autocomplete(waypointInputRef.current, 
                        { types: ['geocode', 'establishment'] }
                    );
                    waypointAutocomplete.addListener('place_changed', () => {
                        const place = waypointAutocomplete.getPlace();
                        if (place && place.geometry) {
                            const lat = place.geometry.location.lat();
                            const lng = place.geometry.location.lng();
                            const address = place.formatted_address || '';
                            if (!address || wayPointArr.some(wp => wp.address === address)) {
                                setWaypointInputValue('');
                                return;
                            }
                            const newWaypoint = {
                                address,
                                stop_id: wayPointArr.length + 1,
                                latitude: lat,
                                longitude: lng,
                                // arrived_at: new Date().toISOString()
                            };
                            setLocationsModified(true); // Set flag when user adds a waypoint
                            setWayPointArr(arr => {
                                const updated = [...arr, newWaypoint];
                                // Always re-index stop_id
                                const reindexed = updated.map((item, i) => ({ ...item, stop_id: i + 1 }));
                                
                                // Recalculate route with updated waypoints
                                if (pickupLat && pickupLng && dropLat && dropLng) {
                                    const origin = { 
                                        lat: parseFloat(pickupLat), 
                                        lng: parseFloat(pickupLng) 
                                    };
                                    const destination = { 
                                        lat: parseFloat(dropLat), 
                                        lng: parseFloat(dropLng) 
                                    };
                                    calculateRoute(origin, destination, reindexed);
                                }
                                
                                return reindexed;
                            });
                            setWaypointInputValue('');
                            setShowWaypointInput(false); // Hide input after adding waypoint
                        }
                    });
                    waypointInputRef.current._autocompleteAttached = true;
                }
            }
            // Attach Google Places Autocomplete to each waypoint input
            if (window.google && window.google.maps && window.google.maps.places && waypointRefs.current) {
                wayPointArr.forEach((wp, idx) => {
                    const input = waypointRefs.current[idx];
                    if (input && !input._autocompleteAttached) {
                        const ac = new window.google.maps.places.Autocomplete(input, { types: ['geocode'] });
                        ac.addListener('place_changed', () => {
                            const place = ac.getPlace();
                            if (place && place.geometry) {
                                const lat = place.geometry.location.lat();
                                const lng = place.geometry.location.lng();
                                const address = place.formatted_address || '';
                                setLocationsModified(true); // Set flag when user edits a waypoint
                                setWayPointArr(arr => {
                                    const updated = arr.map((item, widx) =>
                                        widx === idx ? { ...item, address, latitude: lat, longitude: lng } : item
                                    );
                                    
                                    // Recalculate route when waypoint is modified
                                    if (pickupLat && pickupLng && dropLat && dropLng) {
                                        const origin = { 
                                            lat: parseFloat(pickupLat), 
                                            lng: parseFloat(pickupLng) 
                                        };
                                        const destination = { 
                                            lat: parseFloat(dropLat), 
                                            lng: parseFloat(dropLng) 
                                        };
                                        calculateRoute(origin, destination, updated);
                                    }
                                    
                                    return updated;
                                });
                            }
                        });
                        input._autocompleteAttached = true;
                    }
                });
            }
        };
        if (isLoaded) {
            loadAutocomplete();
        }
    }, [isLoaded, openEditTrip, wayPointArr, showWaypointInput]);

    return (
        <>
            <Dialog
                open={openCancelConfirmModal}
                onClose={() => setOpenCancelConfirmModal(false)}
                aria-labelledby="cancel-booking-dialog-title"
                aria-describedby="cancel-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Confirm Cancellation</DialogTitle>
                <DialogContent>
                    <DialogContentText id="cancel-booking-dialog-description">
                        Are you sure you want to cancel this booking?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => setOpenCancelConfirmModal(false)} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            if (bookingToCancel) { // Ensure bookingToCancel is set
                                // Temporarily set selectedRow for handleCancelBooking if it strictly relies on it
                                // This is a bit of a workaround if handleCancelBooking isn't updated to use bookingToCancel directly
                                const originalSelectedRow = selectedRow;
                                setSelectedRow(bookingToCancel);
                                handleCancelBooking();
                                setSelectedRow(originalSelectedRow); // Restore original selectedRow if necessary
                            }
                            setOpenCancelConfirmModal(false);
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openMarkNoShowConfirmModal}
                onClose={() => setOpenMarkNoShowConfirmModal(false)}
                aria-labelledby="cancel-booking-dialog-title"
                aria-describedby="cancel-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Mark No Show</DialogTitle>
                <DialogContent>
                    <DialogContentText id="cancel-booking-dialog-description">
                        Are you sure you want to mark this trip as no show?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => setOpenMarkNoShowConfirmModal(false)} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            if (bookingtomarkNoShow) { // Ensure bookingToCancel is set
                                // Temporarily set selectedRow for handleCancelBooking if it strictly relies on it
                                // This is a bit of a workaround if handleCancelBooking isn't updated to use bookingToCancel directly
                                const originalSelectedRow = selectedRow;
                                setSelectedRow(bookingtomarkNoShow);
                                handleMarkNoShowBooking();
                                setSelectedRow(originalSelectedRow); // Restore original selectedRow if necessary
                            }
                            setOpenMarkNoShowConfirmModal(false);
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openDeleteConfirmModal}
                onClose={() => setOpenDeleteConfirmModal(false)}
                aria-labelledby="cancel-booking-dialog-title"
                aria-describedby="cancel-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Delete Trip Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText id="cancel-booking-dialog-description">
                        Are you sure you want to delete this trip? 
                        <br/> This cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => setOpenDeleteConfirmModal(false)} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            if (bookingToDelete) { // Ensure bookingToCancel is set
                                // Temporarily set selectedRow for handleCancelBooking if it strictly relies on it
                                // This is a bit of a workaround if handleCancelBooking isn't updated to use bookingToCancel directly
                                const originalSelectedRow = selectedRow;
                                setSelectedRow(bookingToDelete);
                                handleDeleteBooking();
                                setSelectedRow(originalSelectedRow); // Restore original selectedRow if necessary
                            }
                            setOpenDeleteConfirmModal(false);
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openUnassign}
                onClose={() => setOpenUnassign(false)}
                aria-labelledby="unassign-booking-dialog-title"
                aria-describedby="unassign-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="unassign-booking-dialog-title" sx={{fontWeight:'bold'}}>Unassign Trip Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText id="unassign-booking-dialog-description">
                        Are you sure you want to unassign this trip? 
                        <br/>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => setOpenUnassign(false)} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            if (unassignDriver) { // Ensure bookingToCancel is set
                                // Temporarily set selectedRow for handleCancelBooking if it strictly relies on it
                                // This is a bit of a workaround if handleCancelBooking isn't updated to use bookingToCancel directly
                                const originalSelectedRow = selectedRow;
                                setSelectedRow(unassignDriver);
                                handleUnassignSubmit();
                                setSelectedRow(originalSelectedRow); // Restore original selectedRow if necessary
                            }
                            setOpenUnassign(false);
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Assigned Trips
            </Typography>

            <Grid2 container alignItems="center" style={{ marginTop: '1%', marginBottom: '1%', alignItems:'center' }}>
                <Grid2 item>
                    <Label></Label>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'40px', marginTop:'20px',borderRadius:'8px',backgroundColor: '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item sx={{marginLeft:'1%'}}>
                    <Label>Booking Mode:</Label><br/>
                    <Select value={bookingModeFilter}
                        onChange={handleBookingModeChange} displayEmpty
                        style={{width: '190px',height:'40px', marginTop:'4px', borderRadius:'8px', backgroundColor: bookingModeFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        {bookingModeOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item sx={{marginLeft:'1%'}}>
                    <Label>Driver Name:</Label><br/>
                    <TextField 
                        size="small"
                        placeholder="Enter Driver Name"
                        value={driverNameFilter}
                        onChange={(e) => setDriverNameFilter(e.target.value)}
                        sx={{
                            width: '190px',
                            '& .MuiInputBase-root': {
                                height: '40px',
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                                marginTop:'4px'
                            }
                        }}
                    />
                </Grid2>
                
                <Grid2 item sx={{marginLeft:'1%'}}>
                    <Label>Start Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format="DD/MM/YYYY"
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={startDateFilter}
                            onChange={(newValue) => {
                                if (endDateFilter && newValue && newValue.isAfter(endDateFilter)) {
                                    setEndDateFilter(null);
                                }
                                setStartDateFilter(newValue);
                            }}
                            maxDate={endDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item sx={{marginLeft:'1%'}}>
                    <Label>End Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format="DD/MM/YYYY"
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={endDateFilter}
                            onChange={(newValue) => setEndDateFilter(newValue)}
                            minDate={startDateFilter || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item sx={{marginLeft:'1%', marginLeft:'auto'}}>
                    <Label></Label><br/>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={exportCSV}
                        sx={{
                            height: '40px',
                            textTransform: 'none',
                            borderRadius: '8px',
                            backgroundColor: '#36C68F',
                            '&:hover': {
                                backgroundColor: '#36C68F',
                            },
                        }}
                    >
                        Export CSV
                    </Button>
                </Grid2>
            </Grid2>

            <div
                style={{
                    position: 'fixed',
                    top: 65,
                    right: openDetails ? 0 : '-100%',
                    height: '100%',
                    width: '50%',
                    backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,
                    overflowY: 'auto',
                    padding: 20
                }}
            >
                <Box onClose={handleCloseDetails}>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        {/* Close Button Outside the Card */}
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseDetails}
                            style={{
                                position: 'absolute',
                                top: '-15px', // Position it above the Paper component
                                left: '1px',
                                color: '#333',
                                zIndex: 10,
                            }}
                        >
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>
                        <Box sx={{ 
                                maxWidth: '800px', 
                                margin: '0 auto',
                                position: 'relative',
                                marginBottom: '20px',
                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
                            }}>
                            <Paper 
                                elevation={0}
                                style={{ 
                                    padding: '30px', 
                                    backgroundColor: '#FFFFFF', 
                                    borderRadius: '12px',
                                    border: '1px solid #E0E0E0',
                                    position: 'relative'
                                }}>
                            <Typography style={{ marginBottom: '10px', fontWeight: '500', fontSize:'24px' }}>
                                Booking Details
                            </Typography>
                            <hr/>

                            <Grid2 container spacing={2}>
                                <Grid2 item>
                                    <Button variant="contained" sx={{backgroundColor:'#0065ff', borderRadius:'8px', textTransform:'none'}}>Booking ID: {selectedRow?.booking_id}</Button>
                                </Grid2>
                                <Grid2 item sx={{border: '1px solid #0DBA78', borderRadius:'8px', padding:'6px 12px', backgroundColor:'#EFFBF7'}}>
                                    <Typography sx={{color:'#0DBA78'}}>Assigned</Typography>
                                </Grid2>
                            </Grid2>

                            <Grid2>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'20px'}}>User Details</Typography>

                                <Grid2 container spacing={2} sx={{ marginTop:'16px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={3.5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>User Name</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            {selectedRow?.user_image ? <Avatar
                                                sx={{ borderColor: "#0065FF", border: 1, marginRight:'8px' }}
                                                alt="John Doe"
                                                src={selectedRow?.user_image}
                                            ></Avatar> : <Avatar sx={{ borderColor: "#0065FF", border: 1, marginRight:'8px' }} alt='name' src={altProfile}></Avatar>
                                            }
                                            <Typography>{selectedRow?.user_first_name + ' ' + selectedRow?.user_last_name}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Email ID</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <EmailIcon sx={{marginRight:'8px'}}/>
                                            <Typography>{selectedRow?.user_email}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={3.5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Phone Number</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <PhoneIcon sx={{marginRight:'8px'}}/>
                                            <Typography>{selectedRow?.user_phone_number}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={3.5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Company Name</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.user_company_name ? selectedRow?.user_company_name : '--'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>No. of Seats</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <img src={blackSeatIcon} alt="blackSeatIcon"/>
                                            <Typography sx={{marginLeft:'8px'}}>{selectedRow?.ticket_count}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={3}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>No. of Children</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.no_of_childrens ? selectedRow?.no_of_childrens : '0'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={3}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Luggage</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <img src={bagIcon} alt="bagIcon"/>
                                            <Typography sx={{marginLeft:'8px'}}>{selectedRow?.luggage_count}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'20px'}}>Driver Details</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'16px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={3.5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Driver Name</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            {selectedRow?.driver_image ? <Avatar
                                                sx={{ borderColor: "#0065FF", border: 1, marginRight:'8px' }}
                                                alt="John Doe"
                                                src={selectedRow?.driver_image}
                                            ></Avatar> : <Avatar sx={{ borderColor: "#0065FF", border: 1, marginRight:'8px' }} alt='name' src={altProfile}></Avatar>
                                            }
                                            <Typography>{selectedRow?.driver_name}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Email ID</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <EmailIcon sx={{marginRight:'8px'}}/>
                                            <Typography>{selectedRow?.driver_email}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={3.5}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Phone Number</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <PhoneIcon sx={{marginRight:'8px'}}/>
                                            <Typography>{selectedRow?.driver_phone}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'20px'}}>Vehicle Details</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'16px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={2.4}>
                                        <img src={blueCarIcon} alt="blueCarIcon"/>
                                    </Grid2>
                                    {/* <Grid2 item size={3.2}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Vehicle Name</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>Nissan</Typography>
                                        </Grid2>
                                    </Grid2> */}
                                    <Grid2 item size={3.2}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Vehicle Category</Typography>
                                        <Typography>{selectedRow?.vehicle_category ? selectedRow?.vehicle_category : '--'}</Typography>
                                    </Grid2>
                                    <Grid2 item size={3.2}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Vehicle Number</Typography>
                                        <Typography>{selectedRow?.vehicle_number ? selectedRow?.vehicle_number : '--'}</Typography>
                                    </Grid2>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Booking Details</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Booking Mode</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                           <Typography sx={{ minWidth: '100px', color: selectedRow?.source==1 ? '#0C3B7C' : selectedRow?.source==2 ? '#AC8312' : selectedRow?.source==0 ? '#2B7FFF' : selectedRow?.source==-1 ? '#0065FF' : 'Unknown' }}>{selectedRow?.source==1 ? 'PIU' : selectedRow?.source==2 ? 'Transferz' : selectedRow?.source==0 ? 'Others' : selectedRow?.source==-1 ? 'Admin Panel' : 'Unknown'}</Typography>
                                           
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Source ID</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.source_id}</Typography>
                                            
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Date & Time</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <AccessTimeFilledIcon sx={{marginRight:'8px'}}/>
                                            <Typography>{selectedRow?.pickup_time ? new Date(selectedRow?.pickup_time).toLocaleString('en-GB', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true}).replace(',', ' |') : ''}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>
                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Parent Booking ID</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                           <Typography>{selectedRow?.linked_booking_id}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Journey Code</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.journey_code ? selectedRow?.journey_code : '--'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Route Details</Typography>
                                
                                <Grid2 item>
                                    <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'3%'}}>
                                        <img height="22px" width="22px" src={pickupIcon}/>
                                        <Typography sx={{marginLeft:'1%'}}>{selectedRow?.pickup_address}</Typography>
                                    </Grid2>
                                </Grid2>
                                <hr style={{border: 'none', borderTop: '1px dotted #E3E5E8'}}/>
                                <Grid2 item>
                                    <Grid2>
                                        {selectedRow?.way_points?.map((item, index) => (
                                            <>
                                                <div key={index}>
                                                    {(index!=0 && index!=selectedRow?.way_points.length-1) && 
                                                        (
                                                            <>
                                                            <Grid2 sx={{ marginTop:'2%',display:'flex', alignItems:'center'}}>
                                                                <span style={{
                                                                    display: 'inline-block',
                                                                    minWidth: 20,
                                                                    minHeight: 20,
                                                                    borderRadius: '50%',
                                                                    background: '#2A313C',
                                                                    color: '#fff',
                                                                    fontWeight: 500,
                                                                    textAlign: 'center',
                                                                    lineHeight: '20px',
                                                                    marginRight: 8
                                                                }}>{index}</span>
                                                                <Typography>{item.address}</Typography>
                                                                
                                                            </Grid2>
                                                            <hr style={{border: 'none', borderTop: '1px dotted #E3E5E8'}}/>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </>
                                        ))}
                                        {/* {selectedRow?.way_points==null && <Typography variant="subtitle2">--</Typography>} */}
                                    </Grid2>
                                </Grid2>
                                <Grid2 item>
                                    <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'2%', marginBottom:'16px'}}>
                                        <img height="22px" width="22px" src={dropIcon}/>
                                        <Typography sx={{marginLeft:'1%'}}>{selectedRow?.drop_address}</Typography>
                                    </Grid2>
                                </Grid2>


                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Distance (in km)</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{ischange_point_to_comma == '1' ? formatNumber(selectedRow?.distance) : (selectedRow?.distance)}</Typography>
                                            
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Duration (in minutes)</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.duration}</Typography>
                                            
                                        </Grid2>
                                    </Grid2>
                                </Grid2>


                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Flight Details</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={6}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Flight Number</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.flight_number || '--'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Payment Details</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Fare</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>€{ischange_point_to_comma == '1' ? formatNumber(selectedRow?.fare) : (selectedRow?.fare)|| '0'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Tax</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>€{ischange_point_to_comma == '1' ? formatNumber(selectedRow?.tax) : (selectedRow?.tax) || '0'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Partner Price</Typography>
                                        <Typography>€{ischange_point_to_comma == '1' ? formatNumber(selectedRow?.partner_fare ) : (selectedRow?.partner_fare)|| '0'}</Typography>
                                    </Grid2>
                                </Grid2>

                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Extras</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>€{ischange_point_to_comma == '1' ? formatNumber(selectedRow?.extra_fare) : (selectedRow?.extra_fare) || '0'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Total Fare</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>€{ischange_point_to_comma == '1' ? formatNumber(Number(selectedRow?.fare) + Number(selectedRow?.extra_fare) + Number(selectedRow?.tax) + Number(selectedRow?.partner_fare)) : (Number(selectedRow?.fare) + Number(selectedRow?.extra_fare) + Number(selectedRow?.tax) + Number(selectedRow?.partner_fare))}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={4}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Payment Status</Typography>
                                        <Typography sx={{color:selectedRow?.payment_status==1 ? '#0DBA78' : '#AC8312'}}>{selectedRow?.payment_status==0 ? 'Pending' : selectedRow?.payment_status==1 ? 'Paid' : 'Unknown'}</Typography>
                                    </Grid2>
                                </Grid2>

                                <Grid2 item>
                                    <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Payment Mode</Typography>
                                    <Typography>{selectedRow?.payment_mode==1 ? 'Cash' : selectedRow?.payment_mode==2 ? 'Prepaid' : 'Unknown'}</Typography>
                                </Grid2>

                                <hr/>
                                <Typography sx={{fontSize:'20px', fontWeight:'500', marginTop:'12px'}}>Remarks</Typography>
                                <Grid2 container spacing={2} sx={{ marginTop:'8px', alignItems:'center', marginBottom:'16px'}} size={12}>
                                    <Grid2 item size={6}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Driver Remarks</Typography>
                                        <Grid2 sx={{display:'flex', alignItems:'center', marginTop:'4px'}}>
                                            <Typography>{selectedRow?.driver_remarks || '--'}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item size={6}>
                                        <Typography sx={{fontSize:'14px', fontWeight:'500', color:'#83888E'}}>Self Remarks</Typography>
                                        <Typography>{selectedRow?.self_remarks || '--'}</Typography>
                                    </Grid2>
                                </Grid2>
                            </Grid2>

                        </Paper>
                        <div 
                            style={{
                                height: '10px',
                                backgroundColor: '#0065FF',
                                borderRadius: '0 0 12px 12px',
                                marginTop: '-1px',
                                position: 'relative',
                                zIndex: 1
                            }}
                        />
                        </Box>

                    </div>
                </Box>
            </div>

            <TableContainer className="table-container" sx={{ maxHeight:'70vh' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        {visibleHeaders.map(header => {
                            // Map header to data key for sorting
                            let sortKey = '';
                            switch (header) {
                                case 'Booking ID': sortKey = 'booking_id'; break;
                                case 'Booking Mode': sortKey = 'source'; break;
                                case 'Source ID': sortKey = 'source_id'; break;
                                case 'User': sortKey = 'user_first_name'; break;
                                case 'Driver': sortKey = 'driver_name'; break;
                                case 'Date & Time': sortKey = 'pickup_time'; break;
                                case 'Vehicle Number': sortKey = 'vehicle_number'; break;
                                case 'Distance (in km)': sortKey = 'distance'; break;
                                case 'Duration (in min)': sortKey = 'duration'; break;
                                case 'Fare': sortKey = 'fare'; break;
                                case 'Tax': sortKey = 'tax'; break;
                                case 'Extras': sortKey = 'extra_fare'; break;
                                case 'Partner Price': sortKey = 'partner_fare'; break;
                                case 'Total Fare': sortKey = 'total_fare'; break; // If you want to sort by computed total
                                case 'Payment Status': sortKey = 'payment_status'; break;
                                case 'Payment Mode': sortKey = 'payment_mode'; break;
                                case 'Status': sortKey = 'status'; break;
                                case 'Parent Booking ID': sortKey = 'linked_booking_id'; break;
                                case 'Journey Code': sortKey = 'journey_code'; break;
                                default: sortKey = ''; break;
                            }

                            // Only show TableSortLabel if sortable
                            if (sortKey) {
                                return (
                                <TableCell align="center" className="table-header" style={{ width: '15%' }} key={header}>
                                    <TableSortLabel
                                    active={orderBy === sortKey}
                                    direction={orderBy === sortKey ? order : 'asc'}
                                    onClick={() => handleRequestSort(sortKey)}
                                    >
                                    {header}
                                    </TableSortLabel>
                                </TableCell>
                                );
                            } else {
                                // For non-sortable columns like "Action"
                                return (
                                <TableCell align="center" className="table-header" style={{ width: '15%' }} key={header}>
                                    {header}
                                </TableCell>
                                );
                            }
                            })}
                    </TableHead>
                    
                        
                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={16} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                        ).map((row) => {

                            return(
                                <TableRow key={row.tms_client_id}>
                                    {visibleHeaders.map(header => {
                            switch (header) {
                            case 'Booking ID':
                                return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.booking_id}</Typography></TableCell>;
                                    case 'Booking Mode':
                                return <TableCell align="center">
                                        <Typography sx={{ minWidth: '100px', color: row.source==1 ? '#0C3B7C' : row.source==2 ? '#AC8312' : row.source==0 ? '#8f8c81' : row.source==-1 ? '#0065FF' : 'Unknown' }}>{row.source==1 ? 'PIU' : row.source==2 ? 'Transferz' : row.source==0 ? 'Others' : row.source==-1 ? 'Admin Panel' : 'Unknown'}</Typography>
                                    </TableCell>;
                                    case 'Source ID':
                                return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.source_id ? row.source_id : '--'}</Typography></TableCell>;
                                   case 'User':
                                return  <TableCell align="center">
                                        <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                            <Grid2>
                                                {row.user_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={row.user_image}></Avatar>
                                                }
                                                {!row.user_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={altProfile}></Avatar>
                                                }
                                            </Grid2>
                                            <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                <Grid2><Typography>{row.user_first_name + ' ' + row.user_last_name}</Typography></Grid2>
                                                <Grid2><Typography sx={{ color: "#83888E", fontSize: "12px" }}>{row.user_phone_number}</Typography></Grid2>
                                            </Grid2>
                                        </Grid2>
                                    </TableCell>;
                                    case 'Driver' :
                                return <TableCell align="center">
                                        {row.driver_name && 
                                            <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                                <Grid2>
                                                    {row.driver_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={row.driver_image}></Avatar>
                                                    }
                                                    {!row.driver_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={altProfile}></Avatar>
                                                    }
                                                </Grid2>
                                                <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                    <Grid2><Typography>{row.driver_name}</Typography></Grid2>
                                                    <Grid2><Typography sx={{ color: "#83888E", fontSize: "12px" }}>{row.driver_phone}</Typography></Grid2>
                                                </Grid2>
                                            </Grid2>
                                        }
                                        {!row.driver_name && <Typography sx={{ width: 'auto', minWidth: '100px' }}>--</Typography>}
                                    </TableCell>;
                                    case 'Date & Time' : 
                                    return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pickup_time ? new Date(row.pickup_time).toLocaleString('en-GB', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true}).replace(',', ' |') : '--'}</Typography></TableCell>;
                                    case 'Vehicle Number':
                                    return<TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.vehicle_number ? row.vehicle_number : '--'}</Typography></TableCell>;
                                    case 'Distance (in km)' :
                                    return<TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{ischange_point_to_comma == '1' ? formatNumber(row.distance) : (row.distance)}</Typography></TableCell>;
                                    case 'Duration (in min)' : 
                                    return  <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px'}}>{row.duration}</Typography></TableCell>;
                                    case 'Fare' : 
                                    return<TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>€ {ischange_point_to_comma == '1' ? formatNumber(row.fare) : (row.fare)}</Typography></TableCell>;
                                    case 'Tax': 
                                    return<TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{ '€' + (ischange_point_to_comma == '1' ? formatNumber(row.tax): (row.tax) )}</Typography></TableCell>;
                                    case 'Extras' : 
                                    return<TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{ '€' + (ischange_point_to_comma == '1' ? formatNumber(row.extra_fare) : (row.extra_fare) )}</Typography></TableCell>;
                                    case 'Partner Price' : 
                                    return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{ '€' +  (ischange_point_to_comma == '1' ? formatNumber(row.partner_fare) : (row.partner_fare) )}</Typography></TableCell>;
                                    case 'Total Fare' : 
                                    return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color:'#0065FF' }}>{ '€' + (ischange_point_to_comma == '1' ? formatNumber(Number(row.fare) + Number(row.tax) + Number(row.extra_fare) + Number(row.partner_fare)) : (Number(row.fare) + Number(row.tax) + Number(row.extra_fare) + Number(row.partner_fare))  )}</Typography></TableCell>;
                                    case 'Payment Status' : 
                                    return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.payment_status==1 ? 'green' : '#AC8312' }}>{row.payment_status == 0 ? 'Pending' : row.payment_status ==1 ? 'Paid' : 'Unknown'}</Typography></TableCell>;
                                    case 'Payment Mode' : 
                                    return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.payment_mode == 1 ? 'Cash' : row.payment_mode ==2 ? 'Prepaid' : 'Unknown'}</Typography></TableCell>;
                                    case 'Status' : 
                                    return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color:'green' }}>Assigned</Typography></TableCell>;
                                    case 'Parent Booking ID' : 
                                    return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.linked_booking_id==0 ? '--' : row.linked_booking_id}</Typography></TableCell>;
                                    case 'Journey Code' : 
                                    return <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.journey_code ? row.journey_code : '--'}</Typography></TableCell>;
                                    case 'Action' : 
                                    return <TableCell align="center">
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Button
                                                variant="contained"
                                                onClick={() => handleOpenEditTrip(row)}
                                                sx={{
                                                    backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                    borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                    '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                    '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                                }}
                                            >
                                                
                                                <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                            </Button>

                                            <IconButton
                                                aria-label="more options" 
                                                size="small"
                                                onClick={(e) => handleMenuOpen(e, row)}
                                                sx={{ marginLeft: '4px' }}
                                            >
                                                {/* <MoreVertIcon /> */}
                                                <img src={threeDots} alt="threeDots"/>
                                            </IconButton>
                                        </Box>
                                        
                                        <Menu
                                            anchorEl={menuAnchorEl}
                                            open={Boolean(menuAnchorEl) && selectedRow?.tms_client_id === row.tms_client_id}
                                            onClose={handleMenuClose}
                                            PaperProps={{
                                                elevation: 3,
                                                sx: {
                                                    borderRadius: '8px',
                                                    minWidth: '160px',
                                                    padding: '4px 0',
                                                    overflow: 'visible',
                                                    '&:before': {
                                                        content: '""',
                                                        display: 'block',
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 14,
                                                        width: 10,
                                                        height: 10,
                                                        bgcolor: 'background.paper',
                                                        transform: 'translateY(-50%) rotate(45deg)',
                                                        zIndex: 0,
                                                    },
                                                },
                                            }}
                                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                        >
                                            {/* <MenuItem onClick={() => openConfirmDialog('edit')} sx={{ py: 1 }}>
                                                <ListItemText primary="Edit Booking" sx={{ color: '#6B7280' }} />
                                            </MenuItem> */}
                                            <MenuItem onClick={() => openConfirmDialog('view')} sx={{ py: 1 }}>
                                                <ListItemText primary="View Details" sx={{ color: '#6B7280' }} />
                                            </MenuItem>
                                            <MenuItem onClick={() => openConfirmDialog('reassign')} sx={{ py: 1 }}>
                                                <ListItemText primary="Reassign" sx={{ color: '#6B7280' }} />
                                            </MenuItem>
                                            <MenuItem onClick={() => openConfirmDialog('unassign')} sx={{ py: 1 }}>
                                                <ListItemText primary="Unassign" sx={{ color: '#6B7280' }} />
                                            </MenuItem>
                                            <MenuItem onClick={() => openConfirmDialog('cancel', row)} sx={{ py: 1 }}>
                                                <ListItemText primary="Cancel Booking" sx={{ color: '#6B7280' }} />
                                            </MenuItem>
                                            <MenuItem onClick={() => openConfirmDialog('marknoshow', row)} sx={{ py: 1 }}>
                                                <ListItemText primary="Mark No Show" sx={{ color: '#6B7280' }} />
                                            </MenuItem>
                                            <MenuItem onClick={() => openConfirmDialog('delete', row)} sx={{ py: 1 }}>
                                                <ListItemText primary="Delete Trip" sx={{ color: '#D14545' }} />
                                            </MenuItem>
                                        </Menu>
                                    </TableCell>;
                                    
                            default:
                                return <TableCell align="center" key={header}></TableCell>;
                            }
                        })}

                                </TableRow>
                            )
                        })}
                    </TableBody>
                    

                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                        <button
                            onClick={() => handleChangePage(null, page - 1)}
                            disabled={page === 0}
                            className="pagination-arrow"
                        >
                            <img src={prevIcon} alt="Previous" />
                        </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            {openReassign && (
                    <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '38%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                      <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                          <IconButton aria-label="close" onClick={handleClose}
                              style={{
                                  position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                              <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                          </IconButton>
                          
                          <Paper sx={{borderRadius:'12px', padding:'16px'}}>
                            <Typography style={{ marginBottom: '6px', marginTop: '6px', fontWeight: '500', fontSize:'24px' }}>
                              Assign Driver
                            </Typography>
            
                          <Grid container spacing={2} sx={{marginTop:'3%', marginBottom:'2%'}}>
                            <Grid item xs={12} sm={12}>
                              <Label>Assign Driver</Label>
                              <Select 
                                  sx={{
                                    marginTop:'2%',
                                    height: '48px', 
                                    borderRadius: '8px', 
                                    backgroundColor: '#FFFFFF',
                                    '& .MuiSelect-select': {
                                      display: 'flex',
                                      alignItems: 'center',
                                      paddingLeft: '12px'
                                    }
                                  }}
                                  value={assignDriver.driver_id} 
                                  fullWidth
                                  displayEmpty
                                  renderValue={(selected) => {
                                    return (
                                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <PersonIcon sx={{ color: '#666', mr: 1 }} />
                                        {selected ? driversData.find(driver => driver.driver_id === selected)?.driver_name : 'Select Driver'}
                                      </Box>
                                    );
                                  }}
                                  onChange={(e) => {
                                    const selectedDriver = driversData.find(driver => driver.driver_id === e.target.value);
                                    setAssignDriver(prevAssignDriver => ({
                                        ...prevAssignDriver,
                                        driver_id: selectedDriver.driver_id,
                                        // Only update vehicle_make_id from driver if no vehicle is already selected OR if the driver's vehicle is different
                                        // This prioritizes an explicitly chosen vehicle over the driver's default.
                                        // However, if the user picks a driver first, their default vehicle should populate.
                                        // A simpler approach: if a vehicle is already set, don't override it when changing driver.
                                        vehicle_make_id: prevAssignDriver.vehicle_make_id && prevAssignDriver.vehicle_make_id !== '' 
                                                         ? prevAssignDriver.vehicle_make_id 
                                                         : selectedDriver.vehicle_make_id || ''
                                    }));
                                  }}>
                                  <MenuItem value="" disabled>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      <PersonIcon sx={{ color: '#666', mr: 1 }} />
                                      Select Driver
                                    </Box>
                                  </MenuItem>
                                  {driversData && driversData.map((driver) => (
                                    <MenuItem key={driver.driver_id} value={driver.driver_id}>
                                      {driver.driver_name}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </Grid>
            
                            <Grid item xs={12} sm={12}>
                                <Label>Select Vehicle</Label>
                                <Select 
                                  sx={{
                                    marginTop:'2%',
                                    height: '48px', 
                                    borderRadius: '8px', 
                                    backgroundColor: '#FFFFFF',
                                    '& .MuiSelect-select': {
                                      display: 'flex',
                                      alignItems: 'center',
                                      paddingLeft: '12px'
                                    }
                                  }}
                                  value={editVehicleMakeId || assignDriver.vehicle_make_id || ''} 
                                  fullWidth
                                  displayEmpty
                                  renderValue={(selected) => {
                                    const selectedVehicle = vehicleMakeData?.find(vehicle => 
                                      vehicle.vehicle_make_id === selected || vehicle.id === selected);
                                    
                                    return (
                                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={blueCarIcon} alt="Vehicle" style={{ marginRight: '8px', width: '30px', height: '30px' }} />
                                        {selected && selectedVehicle ? selectedVehicle.vehicle_number : 'Select Vehicle'}
                                      </Box>
                                    );
                                  }}
                                  onChange={(e) => {
                                      const selectedId = e.target.value;
                                      setEditVehicleMakeId(selectedId);
                                      
                                      // Find the selected vehicle and update assignDriver
                                      const selectedVehicle = vehicleMakeData.find(vehicle => 
                                          vehicle.vehicle_make_id === selectedId || vehicle.id === selectedId);
                                      if (selectedVehicle) {
                                          // Update assignDriver with the new vehicle info
                                          setAssignDriver(prev => ({
                                              ...prev,
                                              vehicle_make_id: selectedVehicle.vehicle_make_id || selectedVehicle.id,
                                              model_name: selectedVehicle.model_name || '', 
                                              vehicle_number: selectedVehicle.vehicle_number || ''
                                          }));
                                      }
                                  }}>
                                  <MenuItem value="" disabled>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      <img src={blueCarIcon} alt="Vehicle" style={{ marginRight: '8px', width: '24px', height: '24px' }} />
                                      Select Vehicle
                                    </Box>
                                  </MenuItem>
                                  {vehicleMakeData && vehicleMakeData.map((vehicleMake) => (
                                    <MenuItem key={vehicleMake.id || vehicleMake.vehicle_make_id} 
                                      value={vehicleMake.id || vehicleMake.vehicle_make_id}>
                                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {vehicleMake.vehicle_number}
                                      </Box>
                                    </MenuItem>
                                  ))}
                                </Select>
                            </Grid>
                          </Grid>
                          
                          <div style={{ marginTop: '12%', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'6%' }}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleSubmit}
                              disabled={isSaving}
                              sx={{
                                width: '140px',
                                height: '50px',
                                textTransform: 'none',
                                fontSize: '16px',
                                backgroundColor: isSaving ? '#BDBDBD' : '#0065FF',
                                color: 'white',
                                '&:disabled': {
                                  backgroundColor: '#BDBDBD',
                                  color: 'white',
                                }
                              }}>
                              {isSaving ? 'Saving...' : 'Done'}
                            </Button>
                            <Button
                              variant="contained"
                              onClick={handleClose}
                              sx={{
                                width: '140px',
                                height: '50px',
                                textTransform: 'none',
                                fontSize: '16px',
                                backgroundColor: '#F0F0F0',
                                color: '#B0B0B0',
                              }}
                            >
                              Cancel
                            </Button>
                          </div>
            
                          </Paper>
                        </div>
                      </Box>
                    </div>
                  )}

            {openEditTrip && (
                <div 
                style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,overflowY: 'auto',padding: 20
                }}>
                <Box>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        <IconButton aria-label="close" onClick={handleCloseEditTripModal}
                            style={{
                                position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>
                        <Paper elevation={3}
                            style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                            <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                Edit Trip
                            </Typography>

                            <Grid container spacing={2} >
                                <Grid item xs={12} sm={6}>
                                    <Label>Customer First Name<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField sx={{marginTop:'1%'}}
                                        placeholder="Customer First Name" fullWidth variant="outlined" type="text" 
                                        value={customerFirstName}
                                        onChange={(e) => { setCustomerFirstName(e.target.value); if (customerFirstNameError) setCustomerFirstNameError(''); }}
                                        error={!!customerFirstNameError}
                                        helperText={customerFirstNameError}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Label>Customer Last Name<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField sx={{marginTop:'1%'}}
                                        placeholder="Customer Last Name" fullWidth variant="outlined" type="text" 
                                        value={customerLastName}
                                        onChange={(e) => { setCustomerLastName(e.target.value);}}
                                        
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Label>Customer Email<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField sx={{marginTop:'1%'}}
                                        placeholder="Enter Email" fullWidth variant="outlined" type="text" 
                                        value={customerEmail}
                                        onChange={(e) => { 
                                            const value = e.target.value;
                                            setCustomerEmail(value);
                                            
                                            // Clear previous error
                                            if (customerEmailError) setCustomerEmailError('');
                                            
                                            // Validate email format if not empty
                                            if (value && !validateEmail(value)) {
                                                setCustomerEmailError('Please enter a valid email address');
                                            }
                                        }}
                                        error={!!customerEmailError}
                                        helperText={customerEmailError}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Label>Phone No.<span style={{ color: 'red' }}>*</span></Label>
                                    <div>
                                        <PhoneInput
                                            defaultCountry="IN"
                                            value={customerPhone}
                                            onChange={(value) => {
                                                setCustomerPhone(value);
                                                // Clear error when user types
                                                if (customerPhoneError) setCustomerPhoneError('');
                                                
                                                try {
                                                    const parsed = parsePhoneNumber(value);
                                                    if (parsed) {
                                                        setCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                                    }
                                                } catch (err) {
                                                    console.error('Invalid phone number:', err);
                                                    setCountryCode('');
                                                }
                                            }}
                                            // placeholder="Enter phone number"
                                            style={{
                                                height: '44px',
                                                fontSize: '18px',
                                                alignItems: 'normal', 
                                                marginTop:'2%',
                                                borderRadius: '8px',
                                                border: customerPhoneError ? '1px solid #d32f2f' : ''
                                            }}
                                        />
                                        {customerPhoneError && (
                                            <Typography color="error" variant="caption" sx={{ display: 'block', mt: 0.5 }}>
                                                {customerPhoneError}
                                            </Typography>
                                        )}
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Label>Customer Company Name<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField sx={{marginTop:'1%', marginBottom:'6%'}}
                                        placeholder="Customer Company Name" fullWidth variant="outlined" type="text" 
                                        value={companyNameEdited}
                                        onChange={(e) => { setCompanyNameEdited(e.target.value); if (companyNameEditedError) setCompanyNameEditedError(''); }}
                                        error={!!companyNameEditedError}
                                        helperText={companyNameEditedError}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            <Label>Enter Pickup & Drop Location<span style={{ color: 'red' }}>*</span></Label>
                            <Grid2 spacing={2} sx={{backgroundColor:'#F9F9F9', borderRadius:'8px', padding:'2%', marginTop:'1%', marginBottom:'4%'}}>

                                <Grid2 item sx={{ paddingTop:'0px'}}>
                                    <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'8px', paddingLeft:'8px', paddingBottom:'8px', marginTop:'1%', backgroundColor:'#fff'}}>
                                        <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                            <img src={pickupMarker} style={{width:'30px',height:'30px',marginTop:'2%'}}/>
                                            <input ref={inputPickupRef} type="text" placeholder=" Search Pickup Location" className="filterBtn"
                                                style={{
                                                    width:'80%', marginTop:'2%', marginLeft:'2%', border:'1px solid #D1D5DB',
                                                    backgroundPosition: '8px center'
                                                }}
                                                value={pickup}
                                                onChange={(e) => { setPickup(e.target.value); if (pickupError) setPickupError(''); }}
                                            />
                                        </Grid2>
                                        {pickupError && <Typography color="error" variant="caption" sx={{ display: 'block', mt: 0.5 }}>{pickupError}</Typography>}
                                        
                                        {/* Render added waypoints above the input */}


                                        {/* Render added waypoints as before */}
                                        {wayPointArr.length > 0 && wayPointArr.map((wp, idx) => (
                                        <Grid2 key={wp.stop_id} item sx={{display:'flex', alignItems:'center', marginTop: '2%'}}>
                                            <span style={{
                                                display: 'inline-block',
                                                minWidth: 24,
                                                minHeight: 24,
                                                borderRadius: '50%',
                                                background: '#2A313C',
                                                color: '#fff',
                                                fontWeight: 500,
                                                textAlign: 'center',
                                                lineHeight: '24px',
                                                marginRight: 8
                                            }}>{idx + 1}</span>
                                            <input
                                                ref={el => waypointRefs.current[idx] = el}
                                                type="text"
                                                value={wp.address}
                                                placeholder={"Stop " + (idx + 1)}
                                                className="filterBtn"
                                                style={{ flex: 1, marginLeft: '2%', marginRight: '2%', height: '48px', fontSize: '14px', padding: '0px 14px', borderRadius: 8, border: '1px solid #D1D5DB' }}
                                                onChange={e => {
                                                    const newAddress = e.target.value;
                                                    setWayPointArr(arr => arr.map((item, widx) =>
                                                        widx === idx ? { ...item, address: newAddress, latitude: '', longitude: '' } : item
                                                    ));
                                                }}
                                            />
                                            <img src={SubtractCircleSvg} onClick={() => {
                                                setLocationsModified(true); // Set flag when user removes a waypoint
                                                setWayPointArr(arr => {
                                                    const filtered = arr.filter(item => item.stop_id !== wp.stop_id);
                                                    // Re-index stop_id to always be contiguous
                                                    const reindexed = filtered.map((item, i) => ({ ...item, stop_id: i + 1 }));
                                                    
                                                    // Recalculate route when waypoint is deleted
                                                    if (pickupLat && pickupLng && dropLat && dropLng) {
                                                        const origin = { 
                                                            lat: parseFloat(pickupLat), 
                                                            lng: parseFloat(pickupLng) 
                                                        };
                                                        const destination = { 
                                                            lat: parseFloat(dropLat), 
                                                            lng: parseFloat(dropLng) 
                                                        };
                                                        calculateRoute(origin, destination, reindexed);
                                                    }
                                                    
                                                    return reindexed;
                                                });
                                            }} style={{width:'28px',height:'28px', marginRight:'2%', cursor:'pointer'}}/>
                                        </Grid2>
                                        ))}

                                        {showWaypointInput && (
                                        <Grid2 item sx={{display:'flex', alignItems:'center',  marginTop:'2%'}}>
                                            <span style={{
                                                display: 'inline-block',
                                                minWidth: 24,
                                                minHeight: 24,
                                                borderRadius: '50%',
                                                background: '#2A313C',
                                                color: '#fff',
                                                fontWeight: 500,
                                                textAlign: 'center',
                                                lineHeight: '24px',
                                                marginRight: 8
                                            }}>{wayPointArr.length + 1}</span>
                                            <input
                                                ref={waypointInputRef}
                                                type="text"
                                                placeholder={"Stop " + (wayPointArr.length + 1)}
                                                className="filterBtn"
                                                style={{
                                                    width: '79.5%', marginLeft: '2%',marginRight:'2%',
                                                    backgroundPosition: '8px center', border:'1px solid #D1D5DB'
                                                }}
                                                value={waypointInputValue}
                                                onChange={e => setWaypointInputValue(e.target.value)}
                                            />
                                            <img onClick={() => setShowWaypointInput(false)} src={SubtractCircleSvg} style={{width:'28px',height:'28px', cursor:'pointer'}}/>
                                        </Grid2>
                                        )}


                                        <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                            <img src={dropMarker} style={{width:'30px',height:'30px',marginTop:'2%'}}/>
                                            <input ref={inputDropRef} type="text" placeholder=" Search Drop Location" className="filterBtn"
                                                style={{
                                                    width:'80%', marginTop:'2%', marginLeft:'2%', 
                                                    border: dropError ? '1px solid #d32f2f' : '1px solid #D1D5DB',
                                                    backgroundPosition: '8px center'
                                                }}
                                                value={drop}
                                                onChange={(e) => { setDrop(e.target.value); if (dropError) setDropError(''); }}
                                            />
                                            <img onClick={() => {
                                                if(wayPointArr.length >= 3){
                                                    setShowWaypointInput(false)
                                                    setMessage('You can add a maximum of three stops.')
                                                    showSnackbar(true)
                                                }
                                                else{
                                                    setShowWaypointInput(true)
                                                }
                                            }} 
                                            src={AddCircleSvg} style={{width:'28px',height:'28px',marginTop:'2%', cursor:'pointer'}}/>
                                        </Grid2>
                                        {dropError && <Typography color="error" variant="caption" sx={{ display: 'block', mt: 0.5 }}>{dropError}</Typography>}
                                    </Grid2>
                                    
                                </Grid2>

                                

                                <Grid2 item container size={12} spacing={2} sx={{display:'flex', marginTop:'2%'}}>
                                    <Grid2 item size={6}>
                                        <Label>Duration (in minutes)<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'2%'}}
                                            placeholder="Duration" variant="outlined" type="number" 
                                            value={duration} fullWidth disabled
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <AccessTimeFilledIcon sx={{ color: '#666' }} />
                                                    </InputAdornment>
                                                ),
                                                inputProps: { min: 0 },
                                                style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item size={6}>
                                        <Label>Distance (in km)<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'2%'}}
                                            placeholder="Distance (in km)" fullWidth variant="outlined" {...ischange_point_to_comma === '1' ? { type: 'text' } : { type: 'number' }}
                                            value={String(distance)?.replace(".",",")} disabled
                                            // onChange={(e) => { 
                                            //     // Only set non-negative values
                                            //     const value = e.target.value;
                                            //     if (ischange_point_to_comma === '1') {
                                            //         if (value === '' || /^[0-9,]+$/.test(value)) {
                                            //             setDistance(value);
                                            //             if (durationError) setDistanceError('');
                                            //         }}
                                            //     else {if (value === '' || parseFloat(value) >= 0) {
                                            //         setDistance(value);
                                            //         if (priceError) setDistanceError('');
                                            //     }}
                                            // }}
                                            // error={!!distanceError}
                                            // helperText={distanceError}
                                            InputProps={{
                                                inputProps: { min: 0 },
                                                style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                            }}
                                        />
                                    </Grid2>
                                </Grid2>
                            </Grid2>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <Typography sx={{color:'#83888E'}}>Payment Mode</Typography>
                                    <Select sx={{marginTop:'1%'}}
                                        value={paymentMode} 
                                        fullWidth
                                        onChange={(e) => {  
                                            setPaymentMode(e.target.value);
                                        }}
                                        style={{ height: '48px', borderRadius: '8px', backgroundColor: '#f9f9f9'}}>
                                        <MenuItem value="1">Cash</MenuItem>
                                        <MenuItem value="2">Prepaid</MenuItem>
                                    </Select>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography>Price<span style={{ color: 'red' }}>*</span></Typography>
                                    <TextField sx={{marginTop:'1%'}}
                                        placeholder="Price" fullWidth variant="outlined" {...ischange_point_to_comma === '1' ? { type: 'text' } : { type: 'number' }}
                                        value={ischange_point_to_comma == '1' ? String(price).replace(".",",") : price}
                                        onChange={(e) => {
                                        const value = e.target.value;
                                        if (ischange_point_to_comma == '1') {
                                            if (value === '' || /^[0-9r,\.]+$/.test(value)) {
                                            setPrice(value.replace('.', ','));
                                            if (priceError) setPriceError('');
                                            }
                                        } else {
                                            if (value === '' || parseFloat(value) >= 0) {
                                            setPrice(value);
                                            if (priceError) setPriceError('');
                                            }
                                        }
                                        }}
                                            
                                        error={!!priceError}
                                        helperText={priceError}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid>
                                    
                                <Grid item xs={12} sm={6}>
                                    <Typography>Tax</Typography>
                                    <TextField sx={{marginTop:'1%'}}
                                        placeholder="Tax" fullWidth variant="outlined" {...ischange_point_to_comma === '1' ? { type: 'text' } : { type: 'number' }}
                                        value={ischange_point_to_comma == '1' ? String(tax).replace(".",",") : tax}
                                        onChange={(e) => {
                                            // Only set non-negative values
                                            const value = e.target.value;
                                            if (value === '' || parseFloat(value) >= 0) {
                                                setTax(value);
                                            }
                                        }}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography>Partner Price</Typography>
                                    <TextField sx={{marginTop:'1%'}}
                                        placeholder="Partner Price" fullWidth variant="outlined" {...ischange_point_to_comma === '1' ? { type: 'text' } : { type: 'number' }} 
                                        value={ischange_point_to_comma == '1' ? String(partnerPrice).replace(".",",") : partnerPrice}
                                        onChange={(e) => {
                                            // Only set non-negative values
                                            const value = e.target.value;
                                            if (value === '' || parseFloat(value) >= 0) {
                                                setPartnerPrice(value);
                                            }
                                        }}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid>
                                
                                <Grid item xs={12} sm={6}>
                                    <Typography>Extras</Typography>
                                    <TextField sx={{marginTop:'1%'}}
                                        placeholder="Extras" fullWidth variant="outlined" {...ischange_point_to_comma === '1' ? { type: 'text' } : { type: 'number' }}
                                        value={ischange_point_to_comma == '1' ? String(extraPrice).replace(".",",") : extraPrice}
                                        onChange={(e) => {
                                            // Only set non-negative values
                                            const value = e.target.value;
                                            if (value === '' || parseFloat(value) >= 0) {
                                                setExtraPrice(value);
                                            }
                                        }}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} sx={{backgroundColor: '#F9F9F9', alignItems:'center', display:'flex', marginTop:'2%', borderRadius:'8px',padding:'2%', marginLeft:'12px'}}>
                                    <FormControlLabel
                                        control={<Checkbox checked={paymentStatus === 1} onChange={(e) => setPaymentStatus(e.target.checked ? 1 : 0)} />}
                                        label="Paid"
                                    />
                                </Grid>
                            </Grid>

                            <Grid2 container spacing={2} sx={{marginTop:'2%', display:'flex'}}>
                            
                                <Grid2 item size={6}>
                                    <Label>Number of seats<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField sx={{marginTop:'1%'}}
                                        placeholder="Number of seats" fullWidth variant="outlined" type="number" 
                                        value={ticketCountEdited}
                                        onChange={(e) => { 
                                            // Only set non-negative values
                                            const value = e.target.value;
                                            if (value === '' || /^\d+$/.test(value)) {
                                                setTicketCountEdited(value);
                                                if (ticketCountEditedError) setTicketCountEditedError('');
                                            }
                                        }}
                                        error={!!ticketCountEditedError}
                                        helperText={ticketCountEditedError}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <img src={blackSeatIcon} />
                                                </InputAdornment>
                                            ),
                                            inputProps: { min: 0 },
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid2>

                                <Grid2 item size={6}>
                                    <Label>Number of Children</Label>
                                    <TextField sx={{marginTop:'1%'}}
                                        placeholder="Number of Children" fullWidth variant="outlined" type="number" 
                                        value={childrenCountEdited}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Handle empty input
                                            if (value === '') {
                                                setChildrenCountEdited(value);
                                                return;
                                            }
                                            
                                            // Check if value is non-negative
                                            if (parseFloat(value) < 0) {
                                                return; // Don't update for negative values
                                            }
                                            
                                            // Check if value exceeds seats
                                            if (parseInt(value) > parseInt(ticketCountEdited || 0)) {
                                                // Temporarily set the value to show the error
                                                setChildrenCountEdited(value);
                                                return;
                                            }
                                            
                                            // If we get here, the value is valid
                                            setChildrenCountEdited(value);
                                        }}
                                        error={childrenCountEdited !== '' && parseInt(childrenCountEdited) > parseInt(ticketCountEdited || 0)}
                                        helperText={childrenCountEdited !== '' && parseInt(childrenCountEdited) > parseInt(ticketCountEdited || 0) ? 'Number of children cannot exceed total seats' : ''}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid2>
                                
                            </Grid2>

                            <Grid2 container spacing={2} sx={{marginTop:'2%'}}>
                                <Grid2 item size={6}>
                                    <Label>Luggage Count</Label>
                                    <TextField sx={{marginTop:'2%'}}
                                        placeholder="Luggage" fullWidth variant="outlined" type="number" 
                                        value={luggageEdited}
                                        onChange={(e) => {
                                            // Only set non-negative values
                                            const value = e.target.value;
                                            if (value === '' || /^\d+$/.test(value)) {
                                                setLuggageEdited(value);
                                            }
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <img src={bagIcon} />
                                                </InputAdornment>
                                            ),
                                            inputProps: { min: 0 },
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid2>

                                <Grid2 item size={6}>
                                    <Label>Add Flight Number</Label>
                                    <TextField sx={{marginTop:'2%'}}
                                        placeholder="Flight Info" fullWidth variant="outlined" type="text" 
                                        value={flightInfoEdited}
                                        onChange={(e) => setFlightInfoEdited(e.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <img src={flightIcon} />
                                                </InputAdornment>
                                            ),
                                            style: {height: '48px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#f9f9f9', borderRadius:'8px'}
                                        }}
                                    />
                                </Grid2>
                            </Grid2>
    
                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'8%' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={editAssignedTrip}
                                    disabled={isSaving}
                                    sx={{
                                        width: '140px',height: '50px',textTransform: 'none',
                                        fontSize: '16px',
                                        backgroundColor: isSaving ? '#B0B0B0' : '#0065FF',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: isSaving ? '#B0B0B0' : '#0055D4'
                                        }
                                    }}>
                                    {isSaving ? 'Saving...' : 'Save'}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleCloseEditTripModal}
                                    sx={{
                                        width: '140px',
                                        height: '50px',
                                        textTransform: 'none',
                                        fontSize: '16px',
                                        backgroundColor: '#F0F0F0',
                                        color: '#B0B0B0',
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Paper>
    
                    </div>
                </Box>
                </div>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
        </div> {/* Closing the main content div that starts after the Dialog */}
    </> /* Closing the top-level fragment */
    );
};

export default AtAssignedTrips;